//#region Imports

import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, from as fromPromise } from 'rxjs';

import { concatAll, map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { TokenProxy } from '../../../models/proxies/token.proxy';
import { StorageService } from '../../../services/storage/storage.service';

//#endregion

@Injectable()
export class BearerTokenInterceptor implements HttpInterceptor {

  //#region Constructor

  constructor(
    private readonly storage: StorageService,
  ) { }

  //#endregion

  //#region Properties

  public static readonly DISABLE_HEADER: string = 'X-Disabled-BearerToken';

  //#endregion

  //#region Methods

  public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (req.headers.get(BearerTokenInterceptor.DISABLE_HEADER)) {
      return next.handle(req.clone({
        headers: req.headers.delete(BearerTokenInterceptor.DISABLE_HEADER),
      }));
    }

    return fromPromise(this.storage.get<TokenProxy>(environment.storageKeys.userToken))
      .pipe(
        map(result => {
          if (result.error || !result.success)
            return next.handle(req);

          const headers = req.headers.set('Authorization', result.success.token);

          return next.handle(req.clone({ headers }));
        }),
        concatAll(),
      );
  }

  //#endregion

}
